module.exports = __webpack_public_path__ + "static/img/guide-horizontal.3d89dc84.png";